import { InjectionToken, signal, type Signal } from '@angular/core';

export const QUIPPY_PACK_ACTIONS_ENABLED = new InjectionToken<Signal<boolean>>(
    'QuippyPackActionsEnabled',
    { factory: () => signal(false) }
);
